import React from 'react'

import '../assets/styles/base-hub.scss'

const DefaultLayout = ({ children, noHeader, noNavbar, noSidebar, noFooter }) => {
  return <section className='wrapper'>{children}</section>
}

export default DefaultLayout
